import { render, staticRenderFns } from "./result_multiple_products.vue?vue&type=template&id=32c46a2b&scoped=true"
import script from "./result_multiple_products.vue?vue&type=script&lang=js"
export * from "./result_multiple_products.vue?vue&type=script&lang=js"
import style0 from "./result_multiple_products.vue?vue&type=style&index=0&id=32c46a2b&prod&lang=scss&scoped=true"
import style1 from "./result_multiple_products.vue?vue&type=style&index=1&id=32c46a2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c46a2b",
  null
  
)

export default component.exports